<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-model-item label="专区名称" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="siteName">
              <a-input v-model="model.siteName"  :max-length="50" ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="专区编码" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="siteCode">
              <a-input v-model="model.siteCode"  :max-length="36" ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="status">
              <j-dict-select-tag :type="'radio'" v-model="model.status" dictCode="empzone_site_status" allow-clear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="站点介绍" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="siteDesc">
              <a-textarea v-model="model.siteDesc" :rows="3" :maxLength="5" ></a-textarea>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="国家/地区" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="siteArea">
              <j-dict-select-tag :type="'radio'" v-model="model.siteArea" dictCode="empzone_site_area" allow-clear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="员工类型" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="siteEmpType">
              <j-dict-select-tag :type="'radio'" v-model="model.siteEmpType" dictCode="empzone_site_empType" allow-clear/>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: 'EmpzoneSiteForm',
    components: {
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model:{
         },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          siteName: [
            { required: true, message: '请输入站点名称'},
          ],
          siteCode: [
            { required: true, message: '请输入站点code'},
          ],
          status: [
            { required: true, message: '请选择状态'},
          ],
          siteArea: [
            { required: true, message: '请选择国家/地区'},
          ],
          siteEmpType: [
            { required: true, message: '请选择员工类型'},
          ],
        },
        url: {
          add: "/empzone/site/add",
          edit: "/empzone/site/edit",
          queryById: "/empzone/site/empzonesite/"
        }
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
    },
    created () {
       //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      add () {
        this.edit(this.modelDefault);
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            httpAction(httpurl,this.model,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
    }
  }
</script>
